<template>
  <div>
    <main class="single-work">
      <main-header fixed />
      <sui-loader v-show="fetching" class="general-loader" size="large" active centered inline />
      <component
        v-if="!fetching"
        :is="mountComponents(featuredComponent.component)"
        v-bind="getProps(featuredComponent.component, featuredComponent.items)"
      ></component>

      <sui-grid :columns="3" :stretched="true" class="single-work__info" v-show="!fetching">
        <sui-grid-row>
          <sui-grid-column :mobile="16" :computer="4" class="single-work__info__column">
            <h2>{{ title }}</h2>
          </sui-grid-column>
          <sui-grid-column centered :mobile="16" :computer="8" class="single-work__info__column">
            <p>
              {{ description }}
            </p>
          </sui-grid-column>
          <sui-grid-column
            centered
            :mobile="16"
            :computer="4"
            class="single-work__info__lastColumn"
          >
            <div class="single-work__info__cell">
              <span>{{ $t("singleWork.office") }}</span>
              <span class="single-work__info__cell--detail">/ {{ office }}</span>
            </div>
            <div class="single-work__info__cell">
              <span>{{ $t("singleWork.date") }}</span>
              <span class="single-work__info__cell--detail">/ {{ date }}</span>
            </div>

            <div class="single-work__info__cell">
              <span>{{ $t("singleWork.client") }}</span>
              <span class="single-work__info__cell--detail">/ {{ client }}</span>
            </div>
          </sui-grid-column>
        </sui-grid-row>
      </sui-grid>

      <div v-for="component in components" :key="component.component" v-show="!fetching">
        <component
          :is="mountComponents(component.component)"
          v-bind="getProps(component.component, component.items)"
          class="single-work--margin"
        ></component>
      </div>

      <div class="single-work__related" v-show="!fetching">
        <frame-related-posts :slides="relatedProjects" />
      </div>
      <scroll-to />
    </main>

    <main-footer ref="footer" style="bottom: 0;" />
  </div>
</template>

<script>
import PosterGallery from "@/components/frames/poster-gallery";
import GridCollection from "@/components/frames/grid-collection";
import FrameQuotes from "@/components/frames/quotes";
import RelatedPosts from "@/components/frames/related-posts";
import FullImage from "@/components/frames/full-image";

let currentProps = {};

export default {
  name: "single-work",

  components: {
    "frame-poster-gallery": PosterGallery,
    "frame-grid-collection": GridCollection,
    "frame-quotes": FrameQuotes,
    "frame-related-posts": RelatedPosts,
    // eslint-disable-next-line vue/no-unused-components
    "frame-full-image": FullImage,
  },

  data() {
    return {
      title: "Insert The Project Name Here",
      description:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Quis ipsum suspendisse ultrices gravida. Risus commodo viverra maecenas accumsan lacus vel facilisis. ",
      office: "Miami",
      date: "26/05/2020",
      client: "Burguer King",
      fetching: true,
      components: [],
      relatedProjects: [],
      featuredComponent: {},
    };
  },

  mounted() {
    this.getData();

    this.$hub.$on("repeatRequests", (language) => {
      this.getData(language);
    });

    $("body, html").scrollTop(0);
  },

  watch: {
    $route() {
      this.getData();
    },
  },

  computed: {
    isSlider() {
      return (
        (Object.keys(this.featuredComponent).length > 0 &&
          this.featuredComponent.items.length > 1 &&
          this.featuredComponent.component === "video-carrousel") ||
        (Object.keys(this.featuredComponent).length > 0 &&
          this.featuredComponent.items.length > 1 &&
          this.featuredComponent.component === "image-carrousel")
      );
    },

    isFeatured() {
      return (
        this.featuredComponent.component === "video-featured" ||
        this.featuredComponent.component === "image-featured"
      );
    },
  },

  methods: {
    mountComponents(key) {
      if (!key) {
        return null;
      }

      const listComponents = {
        "video-single": "frame-full-video",
        "video-carrousel": "frame-full-video",
        "video-featured": "frame-full-video",
        "image-featured": "frame-full-image",
        "image-carrousel": "frame-full-image",
        "image-single": "frame-full-image",
        "poster-1": "frame-poster-gallery",
        "poster-2": "frame-poster-gallery",
        "poster-3-more": "frame-poster-gallery",
        "poster-3-small": "frame-poster-gallery",
        "poster-3-more-small": "frame-poster-gallery",
        frames: "frame-grid-collection",
        quote: "frame-quotes",
        "quote-2": "frame-quotes",
        "quote-3": "frame-quotes",
      };

      return listComponents[key];
    },

    getProps(key, items) {
      if (!key) {
        return null;
      }

      const listComponents = {
        "video-single": () => {
          currentProps = {
            featured: false,
            isSlider: false,
            videoId: items[0].id,
          };

          return currentProps;
        },
        "video-carrousel": () => {
          currentProps = {
            featured: false,
            isSlider: true,
            videos: items.map((item) => item.id),
          };

          return currentProps;
        },
        "video-featured": () => {
          currentProps = {
            featured: true,
            isSlider: false,
            videoId: items[0].id,
          };

          return currentProps;
        },
        "image-featured": () => {
          currentProps = {
            featured: true,
            isSlider: false,
            images: items[0].url,
          };

          return currentProps;
        },
        "image-carrousel": () => {
          currentProps = {
            isSlider: true,
            images: items.map((item) => item.url),
          };

          return currentProps;
        },
        "image-single": () => {
          currentProps = {
            isSlider: false,
            images: items[0].url,
          };

          return currentProps;
        },
        "poster-1": () => {
          currentProps = {
            isSlider: false,
            slides: items,
          };

          return currentProps;
        },
        "poster-2": () => {
          currentProps = {
            isSlider: false,
            slides: items,
          };

          return currentProps;
        },
        "poster-3-more": () => {
          currentProps = {
            isSlider: true,
            slides: items,
          };

          return currentProps;
        },
        "poster-3-small": () => {
          currentProps = {
            isSlider: false,
            slides: items,
          };

          return currentProps;
        },
        "poster-3-more-small": () => {
          currentProps = {
            isSlider: true,
            slides: items,
          };

          return currentProps;
        },
        frames: () => {
          currentProps = {
            items: items.map((item) => item.url),
          };

          return currentProps;
        },
        quote: () => {
          currentProps = {
            quotes: items,
          };

          return currentProps;
        },
        "quote-2": () => {
          currentProps = {
            quotes: items,
          };

          return currentProps;
        },
        "quote-3": () => {
          currentProps = {
            quotes: items,
          };

          return currentProps;
        },
      };

      return listComponents[key]();
    },

    getData(language) {
      const { lang, slug } = this.$route.params;
      this.fetching = true;

      this.$works
        .getSingle(language || lang, slug)
        .then((response) => {
          const {
            title,
            date,
            category,
            description,
            regional_name,
            client,
            components,
            relatedProjects,
          } = response.data.items;

          this.title = title;
          this.date = date;
          this.category = category;
          this.description = description;
          this.office = regional_name;
          this.client = client;
          this.components = components.filter((item, index) => index !== 0);
          // eslint-disable-next-line prefer-destructuring
          this.featuredComponent = components[0];
          this.relatedProjects = relatedProjects;
          document.dispatchEvent(new Event("prerender-ready"));
        })
        .catch(() => {
          document.dispatchEvent(new Event("prerender-ready"));
        })
        .finally(() => {
          this.fetching = false;
        });
    },
  },
};
</script>

<style lang="scss">
.single-work {
  background: white;
  height: 100%;
  min-height: 100vh;
  overflow: hidden;
  padding-top: 60px;
  position: relative;
  z-index: 2;
  margin-bottom: 300px;

  &--loader {
    &.fixed {
      position: fixed !important;
      top: 10% !important;
      bottom: 0;
      left: 0;
      right: 0;
    }
  }

  &--margin {
    margin: 0px 0 70px;
  }

  &__related {
    margin-top: 70px;
    margin-bottom: 50px;
  }

  &__info {
    margin: 70px 0 !important;
    padding: 0 30px !important;

    h2 {
      font-size: 24px;
      font-family: $david;
      top: -3px;
      position: relative;
    }

    p {
      font-size: 13px;
      text-align: justify;
      color: black;
    }

    &__lastColumn {
      padding: 0 50px !important;
      height: 80px;
    }

    &__cell {
      margin: 0 0 8px;
      font-size: 13px;
      text-align: right;
      display: flex;
      justify-content: left;
      margin-left: 10%;
      justify-content: space-between;

      &--detail {
        text-align: left;

        text-align: left;
        min-width: 120px;
      }

      span {
        &:first-child {
          min-width: 40px;
          margin-right: 30%;
          text-align: left;
        }
      }
    }
  }
}

@media (max-width: 1200px) {
  .single-work {
    &__info {
      p {
        font-size: 15px;
      }

      &__cell {
        span {
          &:first-child {
            margin-right: 15%;
          }
        }
      }
    }
  }
}

@media (max-width: 1000px) {
  .single-work {
    &__related {
      margin-top: 40px;
    }

    &__info {
      padding: 0 20px !important;

      .row {
        padding: 0 !important;

        .column {
          padding: 0 !important;
        }
      }

      p {
        font-size: 15px;
      }

      &__lastColumn {
        padding: 0 50px !important;
        height: 110px;
      }

      &__cell {
        max-width: 80%;
        margin: 0 auto !important;
        width: 100%;
        display: flex;
        padding: 10px 0;

        span {
          font-size: 14px;

          &:first-child {
            margin-right: 15%;
            min-width: 180px;
          }
        }
      }

      &__column {
        margin: 20px 0 !important;
      }
    }
  }
}

@media (max-width: 750px) {
  .single-work {
    &__info {
      margin: 20px 0 !important;

      &__cell {
        span {
          &:first-child {
            margin-right: 15%;
            min-width: 90px;
          }
        }
      }

      &__lastColumn {
        margin-top: 40px !important;
        padding: 0 !important;
      }
    }
  }
}
</style>
